import React from "react";

import { localizer } from "../../../Translator";

import IconButton from '@material-ui/core/IconButton';
import { Grid } from "@material-ui/core";
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { Button } from "@material-ui/core";

import { CardStyled } from "../../common/postal-address/CardStyled";

import { PostalAddressModal } from "./PostalAddressModal";
import MailBox from '../../../images/mailbox.png'

export class PostalAddress extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      // Postal address entity given by parent component PostalAddressList
      postalAddress: this.props.postalAddress,
      log: null,

      // Flag to open/close edit postal address modal
      open: false,

      // Flag to open/close confirm set as default modal
      openConfirmModal: false,
      openRemoveModal: false,

      Notsectionable: false,
    }
  }
  /* Initialization of postal address list. Postal address list is given by parent props */
  componentDidMount() {
    let logo = this.props.postalAddress.logo ? this.props.postalAddress.logo : null
    let url = window.location.href
    let Notsectionable = url.includes("postaladdress")

    this.setState({ logo: logo, Notsectionable: Notsectionable })
  }

  /* Possible actions to perform with a postal address */
  deletePostalAddress = () => {
    this.props.handlePostalAddress(this.state.postalAddress, "DELETE")
  }

  setAsDefault = () => {
    this.props.handlePostalAddress(this.state.postalAddress, "SETASDEFAULT")
  }

  setAsDefault = () => {
    this.props.handlePostalAddress(this.state.postalAddress, "SETASDEFAULT")
    this.doCloseConfirmModal()
  }

  doSelectPostalAddress = () => {
    this.props.handlePostalAddress(this.state.postalAddress, "SELECTADDRESS")
    this.doCloseConfirmModal()
  }
  
  /* Handle modal open/close events */
  editPostalAddress = () => {
    this.setState({ open: !this.state.open })
  }

  handleCloseModal = () => {
    this.setState({ open: false })
  }
  
  doCloseConfirmModal = () => {
    this.setState({ openConfirmModal: false })
  }

  doOpenModal = (event) => {
    let modal = event.target.closest("button").dataset.modal

    switch (modal) {
      case "remove-modal":
        this.setState({ openRemoveModal: true })
        break;
      case "confirm-modal":
        this.setState({ openConfirmModal: true })
        break;
      case "edit-modal":
        this.setState({ open: true })
        break;
      default:
        break;
    }
  }

  render() {

    const isNotDefault = this.state.postalAddress.id !== this.props.defaultAddress
    const logo = this.state.logo
    return (
      <React.Fragment>
        <CardStyled className={isNotDefault ? "" : "default-address"} >
          <CardContent className={this.state.Notsectionable ? "" : "cursor-pointer"} style={{ position: "relative" }} onClick={this.doSelectPostalAddress}>
            {logo ?
              <img src={logo} alt="logo" width={150} height={150}
                style={{
                  opacity: "0.2",
                  position: "absolute",
                  right: "20px"
                }} />
              :
              <img src={MailBox} alt="logo" width={150} height={150}
                style={{
                  position: "absolute",
                  right: "20px"
                }} />
            }
            <Grid container direction="row">
              <Grid item md={7}>
                <Typography className={!isNotDefault ? "typography-generic text-title-star-default " : " typography-generic text-title-star-regular"}>
                  {this.state.postalAddress ? this.state.postalAddress.who : ""}
                </Typography>
              </Grid>
              <Grid item md={4} style={{ textAlign: "right" }}>
                {!isNotDefault &&
                  <Typography className="typography-generic text-star-default">{localizer.PostalAddressDefault}</Typography>
                }
              </Grid>
              <Grid item md={1}>
                {isNotDefault ?
                  <IconButton aria-label="star-regular" className="p-0" onClick={this.setAsDefault}>
                    <i className="fa-regular fa-star star-regular"></i>
                  </IconButton> :
                  <IconButton aria-label="star-default" className="p-0" disabled>
                    <i className="fa-solid fa-star star-default"></i>
                  </IconButton>
                }
              </Grid>
            </Grid>
            <Grid container item md={12}>
              <Typography className="typography-generic" style={{ wordBreak: "break-all"}}>
                {this.state.postalAddress ? this.state.postalAddress.streetType ? this.state.postalAddress.streetType + " " : "" : ""}
                {this.state.postalAddress ? this.state.postalAddress.streetName + ", " : ""}
                {this.state.postalAddress ? this.state.postalAddress.streetNumber ? this.state.postalAddress.streetNumber + " " : "" : ""}
                {this.state.postalAddress ? this.state.postalAddress.streetComplements ? this.state.postalAddress.streetComplements : "" : ""}
              </Typography>
            </Grid>
            <Grid container item md={12}>
              <Typography className="typography-generic">
                {this.state.postalAddress ? this.state.postalAddress.postalCode + ", " : ""}
                {this.state.postalAddress ? this.state.postalAddress.locality + " " : ""}
                {this.state.postalAddress ? this.state.postalAddress.countryIso.toUpperCase() : ""}
              </Typography>
            </Grid>
            <Grid container item md={12}>
              <Typography className="typography-generic">{this.state.postalAddress ? this.state.postalAddress.identityCard : ""}</Typography>
            </Grid>
            <Grid container item md={12}>
              <Typography className="typography-generic">{this.state.postalAddress ? this.state.postalAddress.phone : ""}</Typography>
            </Grid>
          </CardContent>
          <CardActions className="pt-0">
           
            <Button className="button-generic card" variant="outlined" size="small" data-modal="edit-modal" onClick={this.doOpenModal}>{localizer.PostalAddressEdit}</Button>
            {isNotDefault &&
              <div>
                <Button className="button-generic card" variant="outlined" size="small" data-modal="remove-modal" onClick={this.doOpenModal}>{localizer.PostalAddressDelete}</Button>
              </div>
            }
          </CardActions>
        </CardStyled>

        <Dialog
          open={this.state.openConfirmModal}
          onClose={() => { this.setState({ openConfirmModal: false }) }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={() => { this.setState({ openConfirmModal: false }) }}></i>
            <Typography className="typography-generic">{localizer.PostalAddressConfirm}</Typography>
          </DialogTitle>
          <DialogContent dividers={true}>
            <Grid container spacing={4} direction="row" justify="center" alignItems="center" style={{ marginTop: "10px" }}>
              <Grid container item md={12} direction="row" spacing={2}>
                <i className="fa-solid fa-arrow-right-to-city" style={{ margin: "0 auto", fontSize: "35px" }}></i>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2}>
                <Typography className="m-auto typography-generic">{localizer.PostalAddressConfirmText}</Typography>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2}>
                <Button className="button-generic dialog-primary" variant="contained" onClick={this.setAsDefault}>{localizer.PostalAddressSetAsDefault}</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Dialog to confirm the removal the postal */}
        <Dialog
          open={this.state.openRemoveModal}
          onClose={() => { this.setState({ openRemoveModal: false }) }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={() => { this.setState({ openRemoveModal: false }) }}></i>
            <Typography className="typography-generic dialog-title">{localizer.PostalAddressDelete}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={2}>
                <Grid>
                  <Typography className="typography-generic">{localizer.PostalAddressConfirmRemoval}</Typography>
                </Grid>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={() => { this.setState({ openRemoveModal: false }) }}>{localizer.Cancel}</Button>
                <Button name="delete" className="button-generic dialog-delete" variant="contained" onClick={this.deletePostalAddress}>{localizer.Delete}</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        <PostalAddressModal openModal={this.state.open} handleCloseModal={this.handleCloseModal} postalAddress={this.state.postalAddress} handlePostalAddress={this.props.handlePostalAddress}></PostalAddressModal>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/postal-address/sections/PostalAddress.js